export const config = {
  // Inserisci qui il tuo ID di tracciamento (Google Tag Manager o Google Analytics 4)
  // Supporta: 'GTM-XXXXXX' (Tag Manager) oppure 'G-XXXXXX' (Analytics 4)
  gtmId: 'G-T665TSYYVJ', 
};
